module.exports = __webpack_public_path__ + "img/logo_medical_medium.56dfe348.png";